<template>
    <div>
        <label class="field_label">{{ current_champ.label }}<span class="text-red"
                v-if="current_champ.mandatory == 1">*</span></label>
        <v-select :items="items" @change="remove_empty_values" multiple v-model="selectValue" ref="field"
            @blur="$refs.field.validate()" :disabled="current_champ.disabled || is_disable"
            :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>

    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
    props: ["champ", "inscription", "mode", "is_disable"],
    data() {
        return {
            current_champ: {},
            items: [],
        };
    },
    computed: {
        ...mapStores(useMainStore),

        // Propriété computed pour l'interface v-select (convertit string vers tableau)
        selectValue: {
            get() {
                if (this.current_champ.value && typeof this.current_champ.value === 'string') {
                    const values = this.current_champ.value.split(',').filter(value => value.trim() !== '');
                    // Valider que les valeurs existent dans les options disponibles
                    return this.validateAndFilterValues(values);
                }
                return [];
            },
            set(newArrayValue) {
                if (newArrayValue && Array.isArray(newArrayValue)) {
                    // Filtrer les valeurs vides et valider contre les options
                    const filteredValue = newArrayValue.filter(value => value !== "");
                    const validValues = this.validateAndFilterValues(filteredValue);
                    this.current_champ.value = validValues.join(',');
                } else {
                    this.current_champ.value = '';
                }
            }
        },

        // Propriété computed pour accéder directement à la valeur string
        valueAsString: {
            get() {
                return this.current_champ.value || '';
            },
            set(newStringValue) {
                this.current_champ.value = newStringValue || '';
            }
        }
    },
    watch: {
        champ: {
            deep: true,
            handler() {
                this.current_champ = this.champ;

                this.$forceUpdate();
            },
        },
        'current_champ.value': {
            handler(newValue) {
                // Nettoyer la valeur string si nécessaire
                if (newValue && typeof newValue === 'string') {
                    const cleanedValue = newValue.split(',').filter(value => value.trim() !== '').join(',');
                    if (cleanedValue !== newValue) {
                        this.$nextTick(() => {
                            this.current_champ.value = cleanedValue;
                            this.$forceUpdate();
                        });
                    }
                }
            },
        },

        // Watcher pour détecter les changements externes de la valeur string
        valueAsString: {
            handler(newStringValue) {
                // Émettre un événement pour notifier les changements
                this.$emit('value-changed', {
                    stringValue: newStringValue,
                    arrayValue: this.selectValue
                });
            }
        },

        // Watcher pour revalider les valeurs quand les items changent
        items: {
            handler() {
                if (this.current_champ.value && typeof this.current_champ.value === 'string') {
                    this.cleanExistingValues();
                }
            }
        },
    },
    methods: {
        remove_empty_values() {
            // Cette méthode est maintenant gérée automatiquement par selectValue
            // Le filtrage des valeurs vides se fait dans le setter de selectValue
        },

        // Méthode pour obtenir la valeur sous forme de string séparée par virgules
        getValueAsString() {
            return this.valueAsString;
        },

        // Méthode pour définir la valeur à partir d'un string séparé par virgules
        setValueFromString(stringValue) {
            this.valueAsString = stringValue;
        },

        // Méthode pour valider et filtrer les valeurs selon les options disponibles
        validateAndFilterValues(values) {
            if (!this.items || this.items.length === 0) {
                return values; // Si pas d'options, retourner les valeurs telles quelles
            }

            // Extraire les valeurs valides des items
            const validValues = this.items.map(item => {
                // Gérer différents formats d'items (string ou object)
                return typeof item === 'string' ? item : item.value || item.text || item;
            });

            // Filtrer les valeurs pour ne garder que celles qui existent dans les options
            const filteredValues = values.filter(value => {
                const trimmedValue = value.trim();
                return validValues.includes(trimmedValue);
            });

            // Si des valeurs ont été supprimées, mettre à jour current_champ.value
            if (filteredValues.length !== values.length) {
                const removedValues = values.filter(value => !filteredValues.includes(value));
                console.log(`Valeurs supprimées car non valides: ${removedValues.join(', ')}`);
                this.$nextTick(() => {
                    this.current_champ.value = filteredValues.join(',');
                    this.$forceUpdate();
                });
            }

            return filteredValues;
        },

        populateSelect() {
            this.items = this.$itemsSelect.getSelection(this.current_champ.options, false, true);
            // Nettoyer les valeurs existantes s'il y en a
            this.cleanExistingValues();
        },

        cleanExistingValues() {
            // Nettoyer et valider les valeurs existantes si c'est une string
            if (this.current_champ.value && typeof this.current_champ.value === 'string') {
                const values = this.current_champ.value.split(',').filter(value => value.trim() !== '');
                const validValues = this.validateAndFilterValues(values);
                const cleanedValue = validValues.join(',');
                if (cleanedValue !== this.current_champ.value) {
                    this.current_champ.value = cleanedValue;
                }
            }
        },
    },
    async created() {
        this.current_champ = this.champ;
        this.populateSelect();

    },
};
</script>

<style lang="scss">
.v-autocomplete__content {
    max-height: 300px !important;
    min-height: auto !important;
}
</style>